function RadioInput({ label, options }) {
    return (
      <div className="flex flex-col gap-2">
        <label className="text-gray-600 font-medium">{label}</label>
        <div className="flex gap-4">
          {options.map((option, index) => (
            <div key={index} className="flex items-center gap-2">
              <input type="radio" name={label} className="w-5 h-5" />
              <span>{option}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  export default RadioInput